export default __webpack_public_path__ + "static/media/backgroundSmall.8af0be7e.jpg";